import type { SchemaBuilderExpressionVariablesProps } from "./schema-builder-expression-variables.type";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { SchemaBuilderExpressionVariable } from "../schema-builder-expression-variable";
import { useSchemaBuilderExpressionForm } from "../schema-builder-expression.hook";

const { Title } = Typography;

export const SchemaBuilderExpressionVariables = ({
  name,
  fields,
}: SchemaBuilderExpressionVariablesProps) => {
  const { t } = useTranslation();
  const { variables } = useSchemaBuilderExpressionForm({ name });

  return (
    <div className="schema-builder-expression-variables">
      <Title level={5}>{t("schema:expression.variables.title")}</Title>
      <div className="schema-builder-expression-variables-grid">
        {fields.map((field) => (
          <SchemaBuilderExpressionVariable
            key={field.key}
            variable={variables[field.key]}
            field={field}
          />
        ))}
      </div>
    </div>
  );
};
